import { Type } from "@feathersjs/typebox";
export const NullableSchema = (schema) => Type.Union([schema, Type.Null()]);
export const LiteralUnion = (literals) => Type.Union(literals.map((l) => Type.Literal(l)));
//# sourceMappingURL=typebox.js.map